import React from 'react';
import { IModalData, IModalProps } from '../../../interfaces/interfaces';
import ConfirmModal from './ConfirmModal';
import PersonalizationModal from './PersonalizationModal';
import FavouriteListModal from './FavouriteListModal';
import VideoOverlayModal from './VideoOverlayModal';
import OnboardingModal from './OnboardingModal';
import ContactFormModal from './ContactFormModal';
import AppStoreModal from './AppStoreModal';
import FavouriteListModalEdit from './FavouriteListModalEdit';
import FormsModal from './FormsModal';

function ModalsOutlet(props: { modalData: IModalData }): JSX.Element {
  const { modalData } = props;

  const renderModal = (m: IModalProps) => {
    if (m.type && m.type === 'personalization') {
      return (
        <PersonalizationModal
          key={m.key}
          info={m.info}
          message={m.message}
          onConfirm={m.onConfirm}
          onAbort={m.onAbort}
          confirmText={m.confirmText}
          abortText={m.abortText}
          isLocal={m.isLocal}
        />
      );
    }
    if (m.type && m.type === 'favourite') {
      return (
        <FavouriteListModal
          key={m.key}
          info={m.info}
          message={m.message}
          onConfirm={m.onConfirm}
          onAbort={m.onAbort}
          confirmText={m.confirmText}
          abortText={m.abortText}
          list={m.list}
        />
      );
    }
    if (m.type && m.type === 'video') {
      return (
        <VideoOverlayModal
          key={m.key}
          info={m.info}
          message={m.message}
          onConfirm={m.onConfirm}
          onAbort={m.onAbort}
          confirmText={m.confirmText}
          abortText={m.abortText}
        />
      );
    }
    if (m.type && m.type === 'onboarding') {
      return (
        <OnboardingModal
          key={m.key}
          message={m.message}
          onConfirm={m.onConfirm}
          onAbort={m.onAbort}
          confirmText={m.confirmText}
          abortText={m.abortText}
        />
      );
    }
    if (m.type && m.type === 'contactform') {
      return (
        <ContactFormModal
          key={m.key}
          message={m.message}
          onConfirm={m.onConfirm}
          onAbort={m.onAbort}
          confirmText={m.confirmText}
          abortText={m.abortText}
          data={m.data}
        />
      );
    }

    if (m.type && m.type === 'appstore') {
      return (
        <AppStoreModal
          key={m.key}
          message={m.message}
          onConfirm={m.onConfirm}
          onAbort={m.onAbort}
          confirmText={m.confirmText}
          abortText={m.abortText}
        />
      );
    }
    if (m.type && m.type === 'favouriteEdit') {
      return (
        <FavouriteListModalEdit
          key={m.key}
          info={m.info}
          message={m.message}
          onConfirm={m.onConfirm}
          onAbort={m.onAbort}
          confirmText={m.confirmText}
          abortText={m.abortText}
          list={m.list}
        />
      );
    }

    if (m.type && m.type === 'forms') {
      return (
        <FormsModal
          key={m.key}
          info={m.info}
          message={m.message}
          onConfirm={m.onConfirm}
          onAbort={m.onAbort}
          confirmText={m.confirmText}
          abortText={m.abortText}
          forms={m.data}
        />
      );
    }

    return (
      <ConfirmModal
        key={m.key}
        info={m.info}
        message={m.message}
        onConfirm={m.onConfirm}
        onAbort={m.onAbort}
        confirmText={m.confirmText}
        abortText={m.abortText}
      />
    );
  };

  return (
    <>
      {modalData?.modals.map((m: IModalProps) => {
        return renderModal(m);
      })}
    </>
  );
}
export default ModalsOutlet;
